import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PARTNER_GET_BY_SLUG } from 'api/utilityActionTypes';

export default async function getBySlug(
  { state, utilityApiClient },
  { slug, forceRefresh = false },
) {
  typeCheck('slug::NonEmptyString', slug);

  const currentPartnerStatePath = ['utilityPartners', 'bySlug', slug];
  if (state.get(currentPartnerStatePath) && !forceRefresh) {
    return state.get(currentPartnerStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_GET_BY_SLUG,
    queryId: slug,
    state: state,
    payload: {
      slug,
    },
    onSuccess(partner) {
      if (partner) {
        state.set(currentPartnerStatePath, partner);
      }
    },
  });
}
